import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ChatProvider } from './contexts/ChatContext';
import AuthInterface from './components/auth/AuthInterface';
import ChatInterface from './components/chat/ChatInterface';
import PersonaQuestions from './components/persona/PersonaQuestions';
import PersonaChatPage from './pages/PersonaChatPage';
import './App.css';

function App() {
  const [currentView, setCurrentView] = useState('persona'); // 'persona', 'chat'

  const renderCurrentView = () => {
    switch (currentView) {
      case 'persona':
        return <PersonaQuestions onComplete={() => setCurrentView('chat')} />;
      case 'chat':
        return (
          <div className="app-container">
            <AuthInterface />
            <ChatInterface />
          </div>
        );
      default:
        return <PersonaQuestions onComplete={() => setCurrentView('chat')} />;
    }
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <AuthProvider>
              <ChatProvider>
                {renderCurrentView()}
              </ChatProvider>
            </AuthProvider>
          } />
          <Route path="/chat/:personaId" element={<PersonaChatPage />} />
          {/* Catch-all route for client-side routing - redirect to home */}
          <Route path="*" element={
            <AuthProvider>
              <ChatProvider>
                <div style={{ padding: '20px', textAlign: 'center' }}>
                  <h2>Page Not Found</h2>
                  <p>The page you're looking for doesn't exist.</p>
                  <button onClick={() => window.location.href = '/'}>
                    Go to Home
                  </button>
                </div>
              </ChatProvider>
            </AuthProvider>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;